import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TenantService {
  public tenant: string = '';
  public configurationSetting: string = '*';

  constructor() {
    this.resolveTenant();
  }

  /**
   * Resolves tenant and configuration from the hostname.
   *
   * Supported formats:
   *   - pcs.library.site         → tenant = 'pcs',  configuration = '*'
   *   - eglestonfamily-eg.library.site → tenant = 'eglestonfamily', configuration = 'eg'
   *   - pcs.localhost:4200       → tenant = 'pcs',  configuration = '*'
   *   - thg-cfg.localhost:4200   → tenant = 'thg',  configuration = 'cfg'
   *   - localhost:4200           → tenant from environment.defaultTenant (fallback: 'pcs')
   */
  private resolveTenant(): void {
    const hostname = window.location.hostname; // e.g. 'pcs.localhost' or 'pcs.library.site'
    const nameSplit = hostname.split('.');

    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      // Bare localhost with no subdomain — use environment default
      this.tenant = (environment as any).defaultTenant || 'pcs';
      this.configurationSetting = (environment as any).defaultConfiguration || '*';
    } else {
      // Has subdomain: works for both 'pcs.localhost' and 'pcs.library.site'
      const subdomain = nameSplit[0];
      if (subdomain.indexOf('-') >= 0) {
        const parts = subdomain.split('-');
        this.tenant = parts[0];
        this.configurationSetting = parts[1];
      } else {
        this.tenant = subdomain;
      }
    }
  }
}
